import svc from "../../services/VendorConcentrationMapService";
import {endLoading} from "../globalAction";

export const FETCHING_VENDORS_FROM_API = "vendors/FETCHING_CONTACTS_FROM_API";
export const GET_VENDORS_SUCCESS = "vendors/GET_VENDORS_SUCCESS";
export const GET_VENDORS_FAIL = "vendors/GET_VENDORS_FAIL";
export const GET_FILTER_SUCCESS = "vendors/GET_FILTER_SUCCESS";
export const GET_FILTER_FAIL = "vendors/GET_FILTER_FAIL";
export const TOGGLE_BCP_FUNCTION_FILTER = "vendors/TOGGLE_BCP_FUNCTION_FILTER";
export const TOGGLE_INHERENT_RISK_FILTER = "vendors/TOGGLE_INHERENT_RISK_FILTER";
export const TOGGLE_RESIDUAL_RISK_FILTER = "vendors/TOGGLE_RESIDUAL_RISK_FILTER";
export const TOGGLE_MAP_OVERLAY = "vendors/TOGGLE_MAP_OVERLAY";
export const TOGGLE_EVENT_FILTER = "vendors/TOGGLE_EVENT_FILTER";
export const RESET_FILTER_ON_CLEAR_BUTTON_CLICK = "vendors/RESET_FILTER_ON_CLEAR_BUTTON_CLICK";


export function fetchAllVendors(filters) {
    return (dispatch) => {
        dispatch(setFetching());
        return svc.getVendors(filters)
            .then(result => {
                dispatch({type: GET_VENDORS_SUCCESS, vendors: result});
                dispatch(endLoading());
            })
            .catch(err => {
                dispatch({type: GET_VENDORS_FAIL, err});
                dispatch(endLoading());
            });
    };
}

export function getFilterList() {
    return (dispatch) => {
        return svc.getFilterList
            .then(result => {
                dispatch({type: GET_FILTER_SUCCESS, filters: result});
            })
            .catch(err => dispatch({type: GET_FILTER_FAIL, err}));
    };
}

export function setFetching() {
    return {type: FETCHING_VENDORS_FROM_API};
}

export function toggleInherentRiskFilter(riskFilterName) {
    return {type: TOGGLE_INHERENT_RISK_FILTER, riskFilterName};
}

export function toggleResidualRiskFilter(riskFilterName) {
    return {type: TOGGLE_RESIDUAL_RISK_FILTER, riskFilterName};
}

export function toggleBcpFunctionFilter(riskFilterName) {
    return {type: TOGGLE_BCP_FUNCTION_FILTER, riskFilterName};
}

export function toggleEventFilters(eventFilterName) {
    return {type: TOGGLE_EVENT_FILTER, eventFilterName};
}

export function resetFilterOnClearButtonClick(filterName) {
    return {type: RESET_FILTER_ON_CLEAR_BUTTON_CLICK, filterName};
}

export function refreshData(filters) {
    return (dispatch) => {
        dispatch(setFetching());
        dispatch(fetchAllVendors(filters));
    };
}
